import { defineStore } from 'pinia'
export const useDipGroupStore = defineStore('dipGroup', {
  state: () => ({
    idStatus: [],
    valueRef: 'homePage', // 首页附页标识
    bah: '' //病案号
  })
})
